var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"market-w",attrs:{"id":"market"}}),_c('div',{staticClass:"loading-end"},[_vm._v(_vm._s(_vm.isLoading))])])
}
var staticRenderFns = []

export { render, staticRenderFns }